import { render, staticRenderFns } from "./DescriptiveAnalysis.vue?vue&type=template&id=61f400e5&"
import script from "./DescriptiveAnalysis.vue?vue&type=script&lang=js&"
export * from "./DescriptiveAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61f400e5')) {
      api.createRecord('61f400e5', component.options)
    } else {
      api.reload('61f400e5', component.options)
    }
    module.hot.accept("./DescriptiveAnalysis.vue?vue&type=template&id=61f400e5&", function () {
      api.rerender('61f400e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wla/DescriptiveAnalysis.vue"
export default component.exports